export var ParticipationTypeMask;
(function (ParticipationTypeMask) {
    ParticipationTypeMask[ParticipationTypeMask["From"] = 1] = "From";
    ParticipationTypeMask[ParticipationTypeMask["To"] = 2] = "To";
})(ParticipationTypeMask || (ParticipationTypeMask = {}));
export const CallDirection = {
    Outgoing: true,
    Incoming: false,
};
